// @ts-ignore - Cesium module resolution issue
import * as Cesium from 'cesium';
import { extractBounds, extractRasterDimensions } from './types';
export const loadGroundOverlay = (artifactId, imageData, metadata, deps) => {
    const { viewer, artifactActions, addStatus } = deps;
    try {
        const bounds = extractBounds(metadata);
        if (!bounds || typeof bounds.west === 'undefined' || typeof bounds.south === 'undefined' ||
            typeof bounds.east === 'undefined' || typeof bounds.north === 'undefined') {
            addStatus(`Invalid or missing bounds for: ${metadata.getName()}`);
            return;
        }
        const imageBlob = new Blob([imageData], { type: 'image/png' });
        const blobUrl = URL.createObjectURL(imageBlob);
        const rectangle = Cesium.Rectangle.fromDegrees(bounds.west, bounds.south, bounds.east, bounds.north);
        const { width: tileWidth, height: tileHeight } = extractRasterDimensions(metadata);
        const imageryProvider = new Cesium.SingleTileImageryProvider({
            tileWidth: tileWidth,
            tileHeight: tileHeight,
            url: blobUrl,
            rectangle: rectangle
        });
        const imageryLayer = viewer.imageryLayers.addImageryProvider(imageryProvider);
        imageryLayer.alpha = 0.7;
        artifactActions.updateLoaded(artifactId, {
            type: 'raster',
            cesiumObject: imageryLayer,
            metadata: metadata,
            blobUrl: blobUrl
        });
        artifactActions.resetRetryCount(artifactId);
        artifactActions.initControlsIfAbsent(artifactId, { opacity: 0.7 });
        artifactActions.updateVisibility(artifactId, true);
        artifactActions.setLoading(artifactId, false);
    }
    catch (error) {
        artifactActions.setLoading(artifactId, false);
        addStatus(`Error creating ground overlay: ${error}`);
    }
};
export const loadGroundOverlayFromUrl = (artifactId, url, metadata, deps) => {
    const { viewer, artifactActions, addStatus } = deps;
    try {
        const bounds = extractBounds(metadata);
        if (!bounds || typeof bounds.west === 'undefined' || typeof bounds.south === 'undefined' ||
            typeof bounds.east === 'undefined' || typeof bounds.north === 'undefined') {
            addStatus(`Invalid or missing bounds for: ${metadata.getName()}`);
            return;
        }
        const rectangle = Cesium.Rectangle.fromDegrees(bounds.west, bounds.south, bounds.east, bounds.north);
        const { width: tileWidth, height: tileHeight } = extractRasterDimensions(metadata);
        const imageryProvider = new Cesium.SingleTileImageryProvider({
            url,
            rectangle,
            tileWidth: tileWidth,
            tileHeight: tileHeight
        });
        const imageryLayer = viewer.imageryLayers.addImageryProvider(imageryProvider);
        imageryLayer.alpha = 0.7;
        artifactActions.updateLoaded(artifactId, {
            type: 'raster',
            cesiumObject: imageryLayer,
            metadata
        });
        artifactActions.resetRetryCount(artifactId);
        artifactActions.initControlsIfAbsent(artifactId, { opacity: 0.7 });
        artifactActions.updateVisibility(artifactId, true);
        artifactActions.setLoading(artifactId, false);
    }
    catch (error) {
        artifactActions.setLoading(artifactId, false);
        addStatus(`Error creating ground overlay from URL: ${error}`);
    }
};
